import { render } from "./TheHeaderDigitalID.vue?vue&type=template&id=a45f801a&scoped=true"
import script from "./TheHeaderDigitalID.vue?vue&type=script&lang=js"
export * from "./TheHeaderDigitalID.vue?vue&type=script&lang=js"

import "./TheHeaderDigitalID.vue?vue&type=style&index=0&id=a45f801a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45f801a"]])

export default __exports__